<template>
  <BaseSidebar
    ref="sidebar"
    :position="windowWidth > 768 ? 'right' : 'left'"
    @close="$emit('close')"
  >
    <div
      v-resize:window="handleResizeWindow"
      class="h-full px-4 py-8 gap-8 flex flex-col bg-[#F1F1F1]"
    >
      <div v-if="isAuthorized" class="gap-2 flex items-center">
        <div
          class="size-[46px] flex items-center justify-center text-3xl font-semibold text-[#F1F1F1] bg-[#7C7C7C55] rounded-full"
        >
          {{ user.name[0] }}
        </div>

        <div class="flex flex-col text-left">
          <span class="font-semibold">{{ user.name }}</span>
          <span class="text-xs text-[#7C7C7C]">{{ user.email }}</span>

          <!-- <div v-if="user?.isPremium" class="flex flex-initial">
            <div
              v-if="user?.isPremium"
              class="mt-1 px-2 py-1 text-white bg-gradient-to-r from-[#FFA52F] to-[#CE3434] text-[10px] rounded-full"
            >
              Premium
            </div>
          </div> -->
        </div>
      </div>

      <BaseButton v-else :to="{ query: { action: 'open-login' } }">
        {{ $t('hub.sidebar.login') }}
      </BaseButton>

      <div class="px-4">
        <div class="h-[2px] w-full bg-[#D9D9D9]" />
      </div>

      <div class="gap-2 flex flex-col">
        <div
          v-for="item in navItems"
          :key="item.label"
          class="gap-4 px-4 py-2 flex items-center rounded-lg cursor-pointer hover:bg-[#E1E1E1]"
          @click="item.handler"
        >
          <img
            v-if="item.src"
            src="/images/capybara-dark-small.png"
            class="w-6 h-6 inline-flex"
          />
          <BaseIcon v-else class="text-2xl" :icon="item.icon" />

          <span>{{ item.label }}</span>
        </div>
      </div>

      <div v-if="isAuthorized" class="mt-auto mb-0">
        <div
          class="gap-4 px-4 py-2 flex items-center text-[#CB3737] rounded-lg cursor-pointer hover:bg-[#CB3737]/10"
          @click="handleLogout"
        >
          <BaseIcon icon="sign-out-alt" class="text-2xl" />
          <span>{{ $t('hub.sidebar.logout') }}</span>
        </div>
      </div>

      <div class="px-4">
        <div class="h-[2px] w-full bg-[#D9D9D9]" />
      </div>

      <div class="flex justify-center">
        <a
          class="underline text-base text-[#7C7C7C]"
          href="mailto:capino.app@gmail.com"
          target="_blank"
        >
          capino.app@gmail.com
        </a>
      </div>
    </div>
  </BaseSidebar>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

import BaseSidebar from '@/components/Base/BaseSidebar.vue'
import BaseButton from '@/components/Base/BaseButton.vue'

export default {
  name: 'HubSidebar',

  components: { BaseSidebar, BaseButton },

  data: () => ({
    windowWidth: 0
  }),

  computed: {
    ...mapState('user', ['user']),
    ...mapGetters('auth', ['isAuthorized']),

    navItems() {
      return [
        {
          src: '/images/capybara-dark-small.png',
          label: this.$t('hub.sidebar.homePage'),
          handler: () => {
            this.$router.push({ name: 'home' })
          }
        },
        this.isAuthorized &&
          this.user.lastPayment?.orderId && {
            icon: 'time-past',
            label: this.$t('hub.sidebar.paymentHistory'),
            handler: () => {
              this.$router.push({ name: 'hub.payment-history' })
            }
          }
      ].filter(Boolean)
    }
  },

  methods: {
    ...mapActions('auth', {
      logout: 'LOGOUT'
    }),

    handleLogout() {
      this.logout()
      this.$router.push({ name: 'home' })
    },

    handleResizeWindow({ x }) {
      this.windowWidth = x
    }
  }
}
</script>
